//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  af: "Afganistan",
  za: "Africa de Sud",
  al: "Albania",
  dz: "Algeria",
  ad: "Andorra",
  ao: "Angola",
  ai: "Anguilla",
  aq: "Antarctica",
  ag: "Antigua și Barbuda",
  sa: "Arabia Saudită",
  ar: "Argentina",
  am: "Armenia",
  aw: "Aruba",
  au: "Australia",
  at: "Austria",
  az: "Azerbaidjan",
  bs: "Bahamas",
  bh: "Bahrain",
  bd: "Bangladesh",
  bb: "Barbados",
  by: "Belarus",
  be: "Belgia",
  bz: "Belize",
  bj: "Benin",
  bm: "Bermuda",
  bt: "Bhutan",
  bo: "Bolivia",
  ba: "Bosnia și Herțegovina",
  bw: "Botswana",
  br: "Brazilia",
  bn: "Brunei",
  bg: "Bulgaria",
  bf: "Burkina Faso",
  bi: "Burundi",
  kh: "Cambodgia",
  cm: "Camerun",
  ca: "Canada",
  cv: "Capul Verde",
  cz: "Cehia",
  cl: "Chile",
  cn: "China",
  td: "Ciad",
  cy: "Cipru",
  co: "Columbia",
  km: "Comore",
  cg: "Congo - Brazzaville",
  cd: "Congo - Kinshasa",
  kp: "Coreea de Nord",
  kr: "Coreea de Sud",
  cr: "Costa Rica",
  ci: "Côte d’Ivoire",
  hr: "Croația",
  cu: "Cuba",
  cw: "Curaçao",
  dk: "Danemarca",
  dj: "Djibouti",
  dm: "Dominica",
  ec: "Ecuador",
  eg: "Egipt",
  sv: "El Salvador",
  ch: "Elveția",
  ae: "Emiratele Arabe Unite",
  er: "Eritreea",
  ee: "Estonia",
  sz: "eSwatini",
  et: "Etiopia",
  fj: "Fiji",
  ph: "Filipine",
  fi: "Finlanda",
  fr: "Franța",
  ga: "Gabon",
  gm: "Gambia",
  ge: "Georgia",
  gs: "Georgia de Sud și Insulele Sandwich de Sud",
  de: "Germania",
  gh: "Ghana",
  gi: "Gibraltar",
  gr: "Grecia",
  gd: "Grenada",
  gl: "Groenlanda",
  gp: "Guadelupa",
  gu: "Guam",
  gt: "Guatemala",
  gg: "Guernsey",
  gn: "Guineea",
  gq: "Guineea Ecuatorială",
  gw: "Guineea-Bissau",
  gy: "Guyana",
  gf: "Guyana Franceză",
  ht: "Haiti",
  hn: "Honduras",
  in: "India",
  id: "Indonezia",
  bv: "Insula Bouvet",
  cx: "Insula Christmas",
  hm: "Insula Heard și Insulele McDonald",
  im: "Insula Man",
  nf: "Insula Norfolk",
  ax: "Insulele Åland",
  bq: "Insulele Caraibe Olandeze",
  ky: "Insulele Cayman",
  cc: "Insulele Cocos (Keeling)",
  ck: "Insulele Cook",
  fk: "Insulele Falkland",
  fo: "Insulele Feroe",
  um: "Insulele Îndepărtate ale S.U.A.",
  mp: "Insulele Mariane de Nord",
  mh: "Insulele Marshall",
  pn: "Insulele Pitcairn",
  sb: "Insulele Solomon",
  tc: "Insulele Turks și Caicos",
  vi: "Insulele Virgine Americane",
  vg: "Insulele Virgine Britanice",
  jo: "Iordania",
  iq: "Irak",
  ir: "Iran",
  ie: "Irlanda",
  is: "Islanda",
  il: "Israel",
  it: "Italia",
  jm: "Jamaica",
  jp: "Japonia",
  je: "Jersey",
  kz: "Kazahstan",
  kg: "Kârgâzstan",
  ke: "Kenya",
  ki: "Kiribati",
  kw: "Kuweit",
  la: "Laos",
  ls: "Lesotho",
  lv: "Letonia",
  lb: "Liban",
  lr: "Liberia",
  ly: "Libia",
  li: "Liechtenstein",
  lt: "Lituania",
  lu: "Luxemburg",
  mk: "Macedonia de Nord",
  mg: "Madagascar",
  mw: "Malawi",
  my: "Malaysia",
  mv: "Maldive",
  ml: "Mali",
  mt: "Malta",
  ma: "Maroc",
  mq: "Martinica",
  mr: "Mauritania",
  mu: "Mauritius",
  yt: "Mayotte",
  mx: "Mexic",
  fm: "Micronezia",
  mc: "Monaco",
  mn: "Mongolia",
  ms: "Montserrat",
  mz: "Mozambic",
  me: "Muntenegru",
  mm: "Myanmar (Birmania)",
  na: "Namibia",
  nr: "Nauru",
  np: "Nepal",
  ni: "Nicaragua",
  ne: "Niger",
  ng: "Nigeria",
  nu: "Niue",
  no: "Norvegia",
  nc: "Noua Caledonie",
  nz: "Noua Zeelandă",
  om: "Oman",
  pk: "Pakistan",
  pw: "Palau",
  pa: "Panama",
  pg: "Papua-Noua Guinee",
  py: "Paraguay",
  pe: "Peru",
  pf: "Polinezia Franceză",
  pl: "Polonia",
  pt: "Portugalia",
  pr: "Puerto Rico",
  qa: "Qatar",
  hk: "R.A.S. Hong Kong a Chinei",
  mo: "R.A.S. Macao, China",
  gb: "Regatul Unit",
  cf: "Republica Centrafricană",
  do: "Republica Dominicană",
  md: "Republica Moldova",
  re: "Réunion",
  ro: "România",
  ru: "Rusia",
  rw: "Rwanda",
  eh: "Sahara Occidentală",
  kn: "Saint Kitts și Nevis",
  vc: "Saint Vincent și Grenadinele",
  bl: "Saint-Barthélemy",
  pm: "Saint-Pierre și Miquelon",
  ws: "Samoa",
  as: "Samoa Americană",
  sm: "San Marino",
  st: "São Tomé și Príncipe",
  sn: "Senegal",
  rs: "Serbia",
  sc: "Seychelles",
  sh: "Sfânta Elena",
  lc: "Sfânta Lucia",
  mf: "Sfântul Martin",
  sl: "Sierra Leone",
  sg: "Singapore",
  sx: "Sint-Maarten",
  sy: "Siria",
  sk: "Slovacia",
  si: "Slovenia",
  so: "Somalia",
  es: "Spania",
  lk: "Sri Lanka",
  us: "Statele Unite ale Americii",
  va: "Statul Cetății Vaticanului",
  sd: "Sudan",
  ss: "Sudanul de Sud",
  se: "Suedia",
  sr: "Suriname",
  sj: "Svalbard și Jan Mayen",
  tj: "Tadjikistan",
  tw: "Taiwan",
  tz: "Tanzania",
  tf: "Teritoriile Australe și Antarctice Franceze",
  ps: "Teritoriile Palestiniene",
  io: "Teritoriul Britanic din Oceanul Indian",
  th: "Thailanda",
  tl: "Timor-Leste",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tt: "Trinidad și Tobago",
  tn: "Tunisia",
  tr: "Turcia",
  tm: "Turkmenistan",
  tv: "Tuvalu",
  nl: "Țările de Jos",
  ua: "Ucraina",
  ug: "Uganda",
  hu: "Ungaria",
  uy: "Uruguay",
  uz: "Uzbekistan",
  vu: "Vanuatu",
  ve: "Venezuela",
  vn: "Vietnam",
  wf: "Wallis și Futuna",
  ye: "Yemen",
  zm: "Zambia",
  zw: "Zimbabwe",
};
